<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [title]="'Pro Added'"
    [class]="extraClass"
    [canGoBack]="false" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'You have'" /><span>&nbsp;</span>
      <tidy-text
        [body]="'<b>' + (creditBalance | tcurrency) + '</b>.'"
        [translate]="false" /><span>&nbsp;</span>
      <tidy-text
        [body]="'Do you want to send'" /><span>&nbsp;</span>
      <tidy-text
        [body]="pro?.first_name"
        [translate]="false" /><span>&nbsp;</span>
      <tidy-text
        [body]="'payment now or later?'" />
    </tidy-row>

    <tidy-card style="padding: 15px 15px 15px 5px">
      <tidy-card-button (action)="goToSendPayment()">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="2" class="vertical-align-center">
                <div style="margin:auto">
                  <tidy-image
                    [src]="'assets/img/payment-method.svg'"
                    [ngStyle]="{'width': '35px'}" />
                </div>
              </ion-col>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="'Send Payment'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'We\'ll send'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="pro?.first_name"
                    [translate]="false" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'an email to accept the payment.'" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-grid>
      </tidy-card-button>
    </tidy-card>

    <tidy-card style="padding: 15px 15px 15px 5px">
      <tidy-card-button (action)="goToSendJobRequest()">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="2" class="vertical-align-center">
                <div style="margin:auto">
                  <tidy-image
                    [src]="'assets/img/checkmark-calendar.svg'"
                    [ngStyle]="{'width': '35px'}" />
                </div>
              </ion-col>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="'Send Job Request'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Send a job request so'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="pro?.first_name" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'can accept and receive payment once it is completed.'" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-grid>
      </tidy-card-button>
    </tidy-card>

    <tidy-card style="padding: 15px 15px 15px 5px">
      <tidy-card-button (action)="goToViewApp()">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="2" class="vertical-align-center">
                <div style="margin:auto">
                  <tidy-image
                    [src]="'assets/img/app.svg'"
                    [ngStyle]="{'width': '45px'}" />
                </div>
              </ion-col>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="'View the App'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Setup checklists, get maintenance suggestions & more.'" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-grid>
      </tidy-card-button>
    </tidy-card>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
